const getValidSlotSizes = ({ adverts: { validSlotSizes } }) => validSlotSizes;

export default getValidSlotSizes;
